"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _definitionhelpers = require("../../../utils/definitionhelpers");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
// libraries
// utils

/* ++++++++++ --------------- LOAD STATE : DEFINITION --------------- ++++++++++ */


var _default = {
  name: 'LoadState',
  group: _definitionhelpers.groupNames.states,
  props: {
    graphicName: {
      type: 'string',
      default: 'insticator-icon',
      options: ['placeholder', 'error-403', 'error-404', 'error-500', 'insight', 'paintbrush', 'embed', 'email', 'payment', 'mobile', 'desktop', 'insticator-icon']
    },
    graphicText: {
      type: 'string'
    },
    bodycopy: {
      type: 'object',
      default: _react.default.createElement("span", null, "Insticator is loading your data.")
    }
  }
};
exports.default = _default;